import React from 'react';
import { Flex, Text, Box } from '@zillow/constellation';
import 'styled-components';
import PropTypes from 'prop-types';
import { useLastValidRefinanceValues, useRefinanceColors } from './RefinanceCalculator.utils.js';
import { getWholeDollars } from '../../utils/zhl-calculator.js';

var LoanProgramLabel = function LoanProgramLabel(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginRight: '$spacing.xs'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "8",
    height: "8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    fill: color
  })));
};
var RefinanceLegend = function RefinanceLegend(_ref2) {
  var className = _ref2.className;
  var values = useLastValidRefinanceValues();
  var colors = useRefinanceColors();
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodyHeading"
  }, "Monthly savings"), /*#__PURE__*/React.createElement(Text, null, getWholeDollars(values.calculations.monthlySavings), " /mo")), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodyHeading"
  }, "New payment"), /*#__PURE__*/React.createElement(Text, null, getWholeDollars(values.calculations.newPayment))), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodyHeading"
  }, "Break even"), values.calculations.breakEven && /*#__PURE__*/React.createElement(Text, null, values.calculations.breakEven, ' ', values.calculations.breakEven === 1 ? 'month' : 'months'), !values.calculations.breakEven && /*#__PURE__*/React.createElement(Text, null, "N/A")), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodyHeading",
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(LoanProgramLabel, {
    color: colors.costsColor
  }), "Costs"), /*#__PURE__*/React.createElement(Text, null, getWholeDollars(values.fields.fees))), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodyHeading",
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(LoanProgramLabel, {
    color: colors.lifetimeSavingsColor
  }), "Lifetime savings"), /*#__PURE__*/React.createElement(Text, null, getWholeDollars(values.calculations.lifetimeSavings))));
};
RefinanceLegend.defaultProps = {
  className: undefined
};
RefinanceLegend.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
var RefinanceLegend$1 = RefinanceLegend;

export { RefinanceLegend$1 as default };
